import {
  IGenericLoginForm,
  IGenericLoginFormSelects,
} from "../../../../components/pages/Settings/GenericLogins/GenericLogins.types";
import { deepClone } from "../../../../utils";

export const defaultData: IGenericLoginForm = {
  name: "",
  email: "",
  pass: "",
  logout: "60",
  logbooks: [],
  perms: [],
  users: [],
};
export const genericDataMapper = (data: any) => {
  if (!data?.list) null;
  const filledData: IGenericLoginForm = deepClone(defaultData);
  const selects: IGenericLoginFormSelects = {
    logbooks: [],
    perms: [],
    users: [],
  };
  Object.keys(filledData).forEach(key => {
    if (key in data.list) {
      if (key === "logbooks") {
        data.list[key].forEach((item: any) => {
          selects.logbooks.push({
            label: item.lbname,
            value: item.lbid,
          });
          if (item.checked) (filledData as any)[key].push(item.lbid);
        });
      } else if (key === "perms") {
        data.list[key].forEach((item: any) => {
          selects.perms.push({
            label: item.name,
            description: item.description,
            value: item.perm,
            group: item.cat,
          });
          if (item.checked) (filledData as any)[key].push(item.perm);
        });
      } else if (key === "users") {
        data.list[key].forEach((item: any) => {
          selects.users.push({
            label:
              (item.ref ?? "") +
              " - " +
              (item.rolename ?? "") +
              " - " +
              item.name,
            value: item.userid,
          });
          if (item.checked) (filledData as any)[key].push(item.userid);
        });
      } else
        filledData[key as keyof typeof filledData] = (
          data.list[key] ? String(data.list[key]) : ""
        ) as any;
    }
  });

  return { filledData, selects } as {
    filledData: IGenericLoginForm;
    selects: IGenericLoginFormSelects;
  };
};
